import img1 from '../images/categories/almonds.webp';
import img2 from '../images/categories/brazil-nuts.webp';
import img3 from '../images/categories/cashews.webp';
import img4 from '../images/categories/pistachios.webp';
import img5 from '../images/categories/raisins.webp';
import img6 from '../images/categories/walnuts.webp';
const categoriesData = [
    {title: 'Almonds', imgSrc: img1, to: '/almonds'},
    {title: 'Cashews', imgSrc: img2, to: '/cashews'},
    {title: 'Raisins', imgSrc: img3, to: '/raisins'},
    {title: 'Pistachios', imgSrc: img4, to: '/pistachios'},
    {title: 'Walnuts', imgSrc: img5, to: '/walnuts'},
    {title: 'Brazil Nuts', imgSrc: img6, to: '/brazil nuts'},
]

export default categoriesData;